import React from "react";
import "./themedCardComponent.css";

const ThemedCardComponent = ({ titleIcon,title, description }) => {
  return (
    <div className="themed-card">
      <div className="themed-card-header">
        {titleIcon && <span className="themed-card-icon">{titleIcon}</span>}
        <h2 className="themed-card-title">{title}</h2>
      </div>
      <p className="themed-card-description">{description}</p>
    </div>
  );
};

export default ThemedCardComponent;
